"use client"
/* */
import { jsx, Fragment } from 'react/jsx-runtime';
import 'react';

const Render = (props) => /* @__PURE__ */ jsx(Fragment, { children: props.children() ?? null });

export { Render };
//# sourceMappingURL=Render.mjs.map
